// extracted by mini-css-extract-plugin
export default {"about-wrapper":"about-wrapper--mp-yLoVf","aboutWrapper":"about-wrapper--mp-yLoVf","about-pledge":"about-pledge--mp-EqdsS","aboutPledge":"about-pledge--mp-EqdsS"};